var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-1 px-3 py-5 sm:px-12 sm:py-8 font-outfit" },
    [
      _vm._m(0),
      _c("div", { staticClass: "flex flex-col gap-4 sm:gap-5" }, [
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Home Environment")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [
              _c("div", { staticClass: "mb-2" }, [_vm._v("Pets")]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                _vm._l(_vm.data.pets, function (pet) {
                  return _c("li", { key: pet }, [_vm._v(_vm._s(pet || "N/A"))])
                }),
                0
              ),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Accessibility Issues"),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.data.accessibility_issues || "N/A")),
              ]),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Safety Concerns"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.data.safety_concerns || "N/A"))]),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Smart Home Features"),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.data.smart_home_features || "N/A")),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex flex-col sm:flex-row sm:gap-8" }, [
          _c(
            "div",
            {
              staticClass: "flex-1 text-sm sm:text-16 font-medium minWContent",
            },
            [_vm._v("Personal Preferences")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-2 text-sm sm:text-16 sm:font-medium text-gray-400",
            },
            [
              _c("div", { staticClass: "mb-2" }, [_vm._v("Hobbies")]),
              _c(
                "ul",
                {
                  staticClass:
                    "list-disc pl-5 space-y-1 text-sm leading-6 sm:leading-snug sm:text-base text-gray-400",
                },
                _vm._l(_vm.data.hobbies, function (hobby) {
                  return _c("li", { key: hobby }, [
                    _vm._v(_vm._s(hobby || "N/A")),
                  ])
                }),
                0
              ),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Interests"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.data.interests || "N/A"))]),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Cultural Considerations"),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.data.cultural_considerations || "N/A")),
              ]),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Religious Practices"),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.data.religious_practices || "N/A")),
              ]),
              _c("div", { staticClass: "my-2 sm:mt-4 sm:mb-2" }, [
                _vm._v("Dietary Restrictions"),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.data.dietary_restrictions || "N/A")),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "justify-between items-center mb-4 pb-4 borderMainClientProfile hidden sm:flex",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Personal Considerations"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }